/**
 * E018-S013-T011: Fullscreen Database Specs
 *
 * Creates the ExtensionType[] array needed for the DatabaseFullscreenEditor.
 *
 * Our FullscreenDatabaseViewExtension uses di.override() to replace views,
 * so we don't need to filter - just add it at the END so it overrides.
 *
 * Cloud extension (user / member / list services) must be configured with
 * the app framework, otherwise member cells and gantt assignee bars fall
 * back to raw user-ids instead of display names + avatars.
 */

import { ViewExtensionManager } from '@blocksuite/affine/ext-loader';
import { getInternalViewExtensions } from '@blocksuite/affine/extensions/view';
import type { ExtensionType } from '@blocksuite/affine/store';
import type { FrameworkProvider } from '@toeverything/infra';

import { CloudViewExtension } from '../cloud';
import { AffineDatabaseViewExtension } from '../database';
import { patchTusDirectUploadExtension } from '../editor-view/tus-upload';
import { FullscreenDatabaseViewExtension } from './index';

export function getFullscreenDatabaseSpecs(
  framework?: FrameworkProvider
): ExtensionType[] {
  const internalExtensions = getInternalViewExtensions();

  // Add our extension at the END - it uses di.override() to replace views
  const manager = new ViewExtensionManager([
    ...internalExtensions,
    CloudViewExtension,
    AffineDatabaseViewExtension,
    FullscreenDatabaseViewExtension,
  ]);

  if (framework) {
    manager.configure(CloudViewExtension, { framework, enableCloud: true });
  }

  const pageSpecs = manager.get('page');
  return framework
    ? [...pageSpecs, patchTusDirectUploadExtension(framework)]
    : pageSpecs;
}
